import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import AppConfig from 'Constants/AppConfig';
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ContractsEndings from './components/contractsending';
import CancelContract from  './components/cancelcontract';
import AgreementProgram from  './components/agreementprogram';
import ContractsPending from './components/contractsPending';
import ProgramInclusions from './components/programinclusions';
import ContractsAccept from './components/contractaccepted';
import NewContract from './components/newcontract';
import ContractInstallment from './components/feeinstallment';

function TabContainer({ children }) {
  return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
          {children}
      </Typography>
  );
} 

const role= localStorage.getItem('user_role');

class contractDashboard extends Component {
  state = {
    activeIndex: 0
}

UNSAFE_componentWillMount() {
  if(role==15){
    this.setState({ activeIndex: 4 });
  }
}

handleChange(event, value) {
    this.setState({ activeIndex: value });
}

  render() {
    const { match, captoreportlist, studentlists, loading } = this.props;
    const { activeIndex } = this.state;
    
    return (
     <>
       <div className="saas-dashboard">
        <Helmet>
               <title> Dashboard | {AppConfig.appTitle}</title>
               <meta name="description" content="Contract" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.contractdashboard" /> } match={match}/>
            <RctCollapsibleCard
                // heading={<IntlMessages id="widgets.basicTab" />}
            >
                <AppBar position="static" color="primary">
                    
                        {role==15 ?
                        <Tabs value={activeIndex} onChange={(e, value) => this.handleChange(e, value)} >
                         <Tab label="Program Inclusions" />
                         </Tabs>
                        :
                        <Tabs 
                        value={activeIndex} 
                        onChange={(e, value) => this.handleChange(e, value)}
                        variant="scrollable"
                        scrollButtons="on">
                        <Tab label="Contracts Pending" />
                        <Tab label="Contracts Accepted" />
                        <Tab label="Contracts Ending" />
                        <Tab label="New Contracts" />
                        <Tab label="Program Inclusions" />
                        <Tab label="Agreement Program" />
                        <Tab label="Cancelled Contracts" />
                        <Tab label="Contract Instalment" />
                        </Tabs>
                        }
                   
                </AppBar>
                {activeIndex === 0 && <TabContainer><ContractsPending/></TabContainer>}
                {activeIndex === 1 && <TabContainer><ContractsAccept/></TabContainer>}
                {activeIndex === 2 && <TabContainer><ContractsEndings/></TabContainer>}
                {activeIndex === 3 && <TabContainer><NewContract/></TabContainer>}
                {activeIndex === 4 && <TabContainer><ProgramInclusions/></TabContainer>}
                {activeIndex === 5 && <TabContainer><AgreementProgram/></TabContainer>}
                {activeIndex === 6 && <TabContainer><CancelContract/></TabContainer>}
                {activeIndex === 7 && <TabContainer><ContractInstallment/></TabContainer>}
            </RctCollapsibleCard>
          </div>
     </>
    );
  }
}

export default contractDashboard;
